import FeatherIcon from "feather-icons-react"
import { useState } from "react";
import { DropdownResume } from "./DropdownResume";
import { GetCompanyData } from "src/graphql/company";
import { formatMoneyWithCurrency } from "src/utils/formatter";
import moment from "moment";
import { GetSII12MonthsPurchases, GetSII12MonthsSales, GetSIILast12MonthsPurchases, GetSIILast12MonthsSales } from "src/graphql/dashboard";

const currentMonthYear = moment().format('MMMM YYYY')
const currentYear = moment().format('YYYY')
const currentMonthFormatted = moment().format('YYYY-MM')

export const ResumeMonthCard = ({ source, companyId, isSale }) => {

  const [isExpanded, setIsExpanded] = useState(false);
  const [period, setPeriod] = useState('2024')

  const { data } = GetCompanyData(companyId)

  const { data: Sales, reexecuteQuery: refetchSales, fetching: loadingSales } = GetSII12MonthsSales(companyId)
  const { data: LastSales, reexecuteQuery: refetchLastSaless } = GetSIILast12MonthsSales(companyId)

  const { data: Purchases, reexecuteQuery: refetchPurchases, fetching: loadingPurchases } = GetSII12MonthsPurchases(companyId)
  const { data: LastPurchases, reexecuteQuery: refetchLastPurchases } = GetSIILast12MonthsPurchases(companyId)

  const companyData = data?.Company
  const totalAnnual = source.reduce((sum, month) => sum + month.sales, 0);

  const currentMonthSale = source.find(month =>
    moment(month.month).add(10,'hours').format('YYYY-MM') === currentMonthFormatted
  )?.sales || 0;

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="tw-bg-gray-100 tw-rounded-md tw-border-solid tw-border-[1px] tw-border-gray-200 tw-w-full tw-py-4 tw-px-6 tw-min-h-[83px]"
      //  onClick={toggleExpand}
      >
        <div className="tw-flex tw-justify-between" onClick={toggleExpand}>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-font-medium tw-text-lg tw-text-black !tw-p-0 !tw-m-0">{companyData?.alias || companyData?.name || ''}</p>
            <p className="tw-font-normal tw-text-gray-600 !tw-p-0 !tw-m-0 tw-capitalize">Monto total {currentMonthYear}</p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <p className="tw-font-medium tw-text-lg tw-text-black !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(currentMonthSale * 1000000)}</p>
            <FeatherIcon icon={`${isExpanded ? 'chevron-down' : 'chevron-right'}`} size={20} className="tw-text-gray-600" strokeWidth={2.5} />
          </div>
        </div>
        <div className={`tw-transition-all tw-duration-300 tw-ease-in-out tw-mt-5 ${isExpanded ? 'tw-block' : 'tw-hidden'}`}>
          <div className="tw-bg-white tw-rounded-md tw-pb-2">
            <DropdownResume
              totalAnnual={totalAnnual}
              companyId={companyId}
              currentYear={currentYear}
              period={'year'}
              period2={period}
              setPeriod={setPeriod}
              LastSales={isSale ? LastSales?.getLast12MonthsNetSales : LastPurchases?.getLast12MonthsNetPurchases}
              Sales={isSale ? Sales?.get12MonthsNetSales : Purchases?.get12MonthsNetPurchases}
            />
          </div>
        </div>
      </div>
    </>
  )
}